import { TooltipModule } from 'primeng-lts/tooltip';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { formPlycaComponent } from './formPlyca.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormGroupComponent } from './formGroup.component';
import { formElementComponent } from './formElement.component';
import { searchOrganizationalUnitsModule } from '../searchOrganizationalUnits/searchOrganizationalUnits.module';
import { UploadFilesModule } from '../common/upload/upload.module';
import { FormService } from './form.service';
import { searchCPVModule } from '../searchCPV/searchCPV.module';
import { searchReportModule } from '../searchReport/searchReport.module';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ValidationResultComponent } from './validationResult.component';
import { FormatDataValueComponent } from './formatDataValue.component';
import { ValidationGroupComponent } from './validationGroup.component';
import { ErrorCounterComponent } from './error.counter.component';
import { DialogService, DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { WaitLoadingModule } from '../common/waitLoading/waitLoading.module';
import { FormControlErrorComponent } from './formControl-error.component';
import { FormControlErrorMessageComponent } from './formControl-errorMessage.component';
import { DirectivesModule } from '../../directives/directives.module';
import { A11yModule } from '@angular/cdk/a11y';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';
import { SubHeaderModule } from '../common/sub-header/sub-header.module';
import { DivisionTreeModule } from '../divisionTree/divisionTree.module';
import { LongTextEditorComponent } from './longTextEditor.component';
import { FormIndexComponent } from './form-index/form-index.component';
import { HtmlEditorComponent } from './htmlEditor.component';
import { AccordionModule } from 'primeng-lts/accordion';
import { ConfirmationService } from 'primeng-lts/api';
import { ButtonModule } from 'primeng-lts/button';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DialogModule } from 'primeng-lts/dialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { EditorModule } from 'primeng-lts/editor';
import { InputTextModule } from 'primeng-lts/inputtext';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { SidebarModule } from 'primeng-lts/sidebar';
import { TabViewModule } from 'primeng-lts/tabview';
import { InputTextareaModule } from 'primeng-lts/inputtextarea';
import { ChipsModule } from 'primeng-lts/chips';
import { InputMaskModule } from 'primeng-lts/inputmask';
import { PanelMenuModule } from 'primeng-lts/panelmenu';
import { TableModule } from 'primeng-lts/table';
import { InputNumberModule } from 'primeng-lts/inputnumber';
import { searchGenericComponent } from '../search/searchGeneric.component';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { MenuModule } from 'primeng-lts/menu';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { MainPipes } from '../../pipes/main-pipes-module';

@NgModule({
  declarations: [
    formElementComponent,
    formPlycaComponent,
    FormGroupComponent,
    ValidationResultComponent,
    FormatDataValueComponent,
    ValidationGroupComponent,
    ErrorCounterComponent,
    FormControlErrorMessageComponent,
    FormControlErrorComponent,
    LongTextEditorComponent,
    FormIndexComponent,
    HtmlEditorComponent,
    searchGenericComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CalendarModule,
    AccordionModule,
    TabViewModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,
    InputTextModule,
    PanelModule,
    InputTextareaModule,
    InputMaskModule,
    EditorModule,
    searchOrganizationalUnitsModule,
    searchCPVModule,
    searchReportModule,
    TableModule,
    UploadFilesModule,
    TranslateModule,
    OverlayPanelModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    DialogModule,
    WaitLoadingModule,
    DirectivesModule,
    ChipsModule,
    A11yModule,
    ScrollPanelModule,
    DossierHeaderModule,
    SubHeaderModule,
    DivisionTreeModule,
    SidebarModule,
    PanelMenuModule,
    InputNumberModule,
    TooltipModule,
    ProgressBarModule,
    MenuModule,
    SelectButtonModule,
    MainPipes,
  ],
  providers: [FormService, DecimalPipe, ConfirmationService, DialogService],

  exports: [
    formElementComponent,
    formPlycaComponent,
    FormGroupComponent,
    ValidationResultComponent,
    FormatDataValueComponent,
    LongTextEditorComponent,
  ],
  // , schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FormPlycaModule { }
